import type { CSSProperties } from 'react';
import { getTransportModeColor } from '@/lib/constants/transport-modes';

export function getTransportModeChipStyle(mode: string): CSSProperties {
  const color = getTransportModeColor(mode);

  return {
    backgroundColor: `${color}14`,
    borderColor: `${color}40`,
    color,
  };
}
